import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes: Array<RouteRecordRaw> = [
  { path: '/',    name: 'home', component: HomeView },
  { path: '/about', name: 'about', component: () => import('../views/AboutView.vue')},
  { path: '/solutions/internet', name: 'internet', component: () => import('../views/InternetView.vue')},
  { path: '/pricing', name: 'pricing', component: () => import('../views/PricingView.vue')},
  { path: '/contact', name: 'contact', component: () => import('../views/ContactView.vue')},
  { path: '/solutions/phone', name: 'phone', component: () => import('../views/PhoneView.vue')},
  { path: '/faq', name: 'faq', component: () => import('../views/FaqView.vue')},
  { path: '/privacy', name: 'privacy', component: () => import('../views/PrivacyView.vue')},
  { path: '/terms', name: 'terms', component: () => import('../views/TermsView.vue')},


]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
